module.exports = __webpack_public_path__ + "images/jd-logo-green-xl@1xf2d7324d4c8dc1fff8de7f8c416aee62.png";